(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('yumm-cart-gift')) {
    customElements.define('yumm-cart-gift', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.cartForm = this.closest('cart-form');
        this.input = this.querySelector('[data-gift-code]');
        this.status = this.querySelector('[data-gift-status]');
        this.applyButton = this.querySelector('[data-gift-apply]');
        this.removeButton = this.querySelector('[data-gift-remove]');
        this.base = window.Shopify?.routes?.root || '/';
        this.code = 't-incense';
        this.applyButton.addEventListener('click', () => this.run(() => this.apply()));
        this.removeButton.addEventListener('click', () => this.run(() => this.remove()));
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.applyButton.click();
          }
        });
        this.onMerge = () => {
          if (this.busy) return;
          this.quantityPending = false;
          this.run(() => this.check());
        };
        this.onQuantity = event => {
          if (!event.target.closest('.cart-item__quantity-input, .quantity-up, .quantity-down, .cart-item__remove')) return;
          this.quantityPending = true;
          this.setLocked(true);
        };
        this.onSubmit = event => {
          if (this.busy || this.quantityPending || this.unsafe) event.preventDefault();
        };
        this.cartForm.addEventListener('submit', this.onSubmit);
        this.cartForm.addEventListener('on:cart:after-merge', this.onMerge);
        this.cartForm.addEventListener('click', this.onQuantity);
        this.cartForm.addEventListener('change', this.onQuantity);
        this.run(() => this.check());
      }
      disconnectedCallback() {
        this.cartForm?.removeEventListener('submit', this.onSubmit);
        this.cartForm?.removeEventListener('on:cart:after-merge', this.onMerge);
        this.cartForm?.removeEventListener('click', this.onQuantity);
        this.cartForm?.removeEventListener('change', this.onQuantity);
      }
      async api(path, body) {
        const response = await fetch(this.base + path, {
          method: body ? 'POST' : 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: body ? { 'Content-Type': 'application/json' } : {},
          ...(body ? { body: JSON.stringify(body) } : {})
        });
        if (!response.ok) throw new Error('cart_request_failed');
        return response.json();
      }
      gifts(cart) {
        return cart.items.filter(item => String(item.variant_id) === this.dataset.variant);
      }
      async removeLegacyGift(cart) {
        const updates = Object.fromEntries(this.gifts(cart).map(item => [item.key, 0]));
        if (!Object.keys(updates).length) return cart;
        const codes = (cart.discount_codes || []).map(item => item.code);
        await this.api('cart/update.js', { updates });
        cart = await this.api('cart/update.js', { discount: codes.join(',') });
        await this.refresh();
        return cart;
      }
      codes(cart) {
        return (cart.discount_codes || []).map(item => item.code).filter(code => code.toLowerCase() !== this.code);
      }
      isQualified(cart) {
        return (cart.discount_codes || []).some(item => item.code.toLowerCase() === this.code && item.applicable === true);
      }
      show(key, free = false) {
        this.status.textContent = this.dataset[key] || '';
        this.removeButton.hidden = !free;
        if (free) this.input.value = this.code;
      }
      setLocked(locked) {
        this.applyButton.disabled = locked;
        this.removeButton.disabled = locked;
        this.input.disabled = locked;
        this.cartForm.toggleAttribute('data-gift-busy', locked);
        const checkout = this.cartForm.querySelector('.checkout-buttons');
        if (checkout) checkout.inert = locked;
      }
      async run(action) {
        if (this.busy || this.quantityPending) return;
        this.busy = true;
        this.setLocked(true);
        try {
          const job = async () => action();
          if (navigator.locks) await navigator.locks.request('yumm-incense-gift', job);
          else await job();
        } catch {
          this.show('review');
          this.unsafe = true;
        } finally {
          this.busy = false;
          this.setLocked(Boolean(this.unsafe));
        }
      }
      async refresh() {
        const response = await fetch(this.base + '?section_id=' + encodeURIComponent(this.cartForm.dataset.sectionId), { cache: 'no-store' });
        if (!response.ok) throw new Error('cart_refresh_failed');
        this.cartForm.refreshFromHtml(await response.text());
      }
      async clearCode(codes) {
        return this.api('cart/update.js', { discount: codes.join(',') });
      }
      async apply() {
        if (this.input.value.trim().toLowerCase() !== this.code) {
          this.show('invalid');
          return;
        }
        this.unsafe = false;
        this.show('loading');
        const original = await this.removeLegacyGift(await this.api('cart.js'));
        const codes = this.codes(original);
        try {
          await this.api('cart/update.js', { discount: [...new Set([...codes, this.code])].join(',') });
          const cart = await this.api('cart.js');
          if (this.isQualified(cart)) {
            await this.refresh();
            this.show('success', true);
          } else {
            await this.clearCode(codes);
            await this.refresh();
            this.show('ineligible');
          }
        } catch {
          await this.clearCode(codes);
          await this.refresh();
          this.show('error');
        }
      }
      async check() {
        this.unsafe = false;
        const cart = await this.removeLegacyGift(await this.api('cart.js'));
        if (this.isQualified(cart)) {
          this.show('success', true);
        } else if ((cart.discount_codes || []).some(item => item.code.toLowerCase() === this.code)) {
          await this.clearCode(this.codes(cart));
          await this.refresh();
          this.show('ineligible');
        } else {
          this.removeButton.hidden = true;
          if (this.status.textContent === this.dataset.success) this.show('removed');
        }
      }
      async remove() {
        this.unsafe = false;
        this.show('loading');
        const cart = await this.api('cart.js');
        await this.clearCode(this.codes(cart));
        await this.refresh();
        this.input.value = '';
        this.show('removed');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
